export default __webpack_public_path__ + "static/media/voucher3.cd5c39e0.png";